import React, { useEffect, useState } from 'react';
import styles from '../../styles/ReporteSeguroAsesoresStyles/ReporteSeguroAsesores.module.css';
import { getCampus } from '../../api/campus';

/**
 * Filtros del Reporte de Seguros de Asesores.
 *
 * NOTA: El filtro de "Ciclo Escolar" fue removido a propósito. Filtraba por
 * `EscAsesor.primer_ciclo_escolar` (ciclo de alta), lo que ocultaba asesores
 * activos dados de alta en otros ciclos. El reporte ahora se acota únicamente
 * por campus.
 *
 * Props:
 *  - filters: { id_campus }
 *  - onChange(key, value)
 *  - onGenerate()
 *  - loading: boolean
 *  - onContextResolved({ campus })
 */
function FiltrosReporteSegurosAsesores({ filters, onChange, onGenerate, loading, onContextResolved }) {
  const [campusList, setCampusList] = useState([]);

  useEffect(() => {
    let mounted = true;
    getCampus()
      .catch(() => [])
      .then((cam) => {
        if (!mounted) return;
        setCampusList(Array.isArray(cam) ? cam : []);
      });
    return () => { mounted = false; };
  }, []);

  const resolveContext = () => {
    const campus = campusList.find((c) => String(c.id) === String(filters.id_campus));
    return {
      campus: campus ? campus.nombre : 'Todos',
    };
  };

  const handleGenerate = () => {
    if (typeof onContextResolved === 'function') {
      onContextResolved(resolveContext());
    }
    onGenerate();
  };

  const disabled = loading;

  return (
    <section className={styles.filtersSection}>
      <div className={styles.filtersRow}>
        <div className={styles.filterGroup}>
          <label className={styles.filterLabel}>Campus</label>
          <select
            className={styles.filterSelect}
            value={filters.id_campus || ''}
            onChange={(e) => onChange('id_campus', e.target.value)}
          >
            <option value="">Todos</option>
            {campusList.map((c) => (
              <option key={c.id} value={c.id}>{c.nombre}</option>
            ))}
          </select>
        </div>

        <div className={styles.filterGroup} style={{ flex: '0 0 auto', minWidth: 'auto' }}>
          <label className={styles.filterLabel}>&nbsp;</label>
          <button
            type="button"
            className={styles.generateButton}
            onClick={handleGenerate}
            disabled={disabled}
          >
            {loading ? 'Generando...' : 'Generar Reporte'}
          </button>
        </div>
      </div>
    </section>
  );
}

export default FiltrosReporteSegurosAsesores;

